import CustomButton from "components/Atoms/CustomButton"
import CustomButtonGroup from "components/Atoms/CustomButtonGroup"
import { useAddUpdateDistributionCentre } from "graphql/distribution-center/distribution-center.hooks"
import React from "react"

const DCMutation = () => {
  const { addUpdate, loading } = useAddUpdateDistributionCentre()
  return (
    <CustomButtonGroup className="w-full" fill vertical>
      <CustomButton
        loading={loading}
        onClick={() => {
          addUpdate()
        }}
        intent="primary"
        text={"Save"}
      />
      <CustomButton
        loading={loading}
        onClick={() => {
          addUpdate(true)
        }}
        className="mt-2"
        text={"Save and add another"}
      />
    </CustomButtonGroup>
  )
}

export default DCMutation
